export const ADMIN = 'admin'
export const Content_Expert = 'Content_Expert'
export const Markerting_User = 'Markerting_User'
export const primary_contact = 'primary_contact'
export const Report_User = 'Report_User'
export const Content_Manager = 'Content_Manager'
export const Seed_Data = 'Seed_Data'
export const Seed_Expert = 'Seed_Expert'
// export const USER = 'user'
